"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Image = _interopRequireDefault(require("../Image"));

var _Video = _interopRequireDefault(require("../Video"));

var Media = function Media(_ref) {
  var mediaType = _ref.mediaType,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["mediaType", "children"]);

  return mediaType === 'video' ? /*#__PURE__*/_react.default.createElement(_Video.default, rest, children) : /*#__PURE__*/_react.default.createElement(_Image.default, Object.assign({}, rest, {
    mediaType: mediaType
  }), children);
};

Media.propTypes = {
  mediaType: _propTypes.default.oneOf(['image', 'backgroundImage', 'video']),
  children: _propTypes.default.node
};
Media.defaultProps = {
  mediaType: 'image',
  children: null
};
var _default = Media;
exports.default = _default;